exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-enter-active[data-v-e38b51d0],.list-leave-active[data-v-e38b51d0]{transition:all .3s}.list-enter[data-v-e38b51d0],.list-leave-to[data-v-e38b51d0]{opacity:0;transform:translateY(-30px)}", ""]);

// exports
